import Toggle from '@mui/material/Switch'
import { styled } from '../../utils/styled'
import Grid from '../Grid'
import type { CSSObject } from '../theme/themeTypes'
import { DROPDOWN_ITEM_CLASS_NAME } from '../Dropdown/classNames'
import { listItemButtonClasses } from '@mui/material'

export const StyledToggle = styled(Toggle)(
  ({ theme }): CSSObject => ({
    width: '58px',
    height: '36px',
    padding: 0,
    overflow: 'visible',
    '&:has( > .Mui-focusVisible)': {
      boxShadow: `${theme.tokens.border.focus.brand.halo} 0px 0px 0px 3px`,
      borderRadius: theme.borderRadius.medium
    },
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&:hover': {
        '& + .MuiSwitch-track': {
          backgroundColor: theme.tokens.foreground.main.disabled
        }
      },
      '&:active': {
        '& + .MuiSwitch-track': {
          backgroundColor: theme.tokens.background.tonal.soft.default
        },
        '& .MuiSwitch-thumb': {
          boxShadow: 'none'
        }
      },
      '&.Mui-checked': {
        transform: 'translateX(22px)',
        color: theme.tokens.foreground.main.primary,
        '& + .MuiSwitch-track': {
          backgroundColor: theme.tokens.background.brand.main.default,
          opacity: 1,
          border: 0
        },
        '&:hover': {
          '& + .MuiSwitch-track': {
            backgroundColor: theme.tokens.background.brand.main.hover
          }
        },
        '&:active': {
          '& + .MuiSwitch-track': {
            backgroundColor: theme.tokens.background.brand.main.pressed
          },
          color: theme.tokens.foreground.main.staticWhite,
          '& > div': {
            backgroundColor: theme.tokens.background.brand.main.hover
          }
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 1
        }
      },
      '&.Mui-disabled': {
        color: theme.tokens.foreground.main.disabled
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        backgroundColor: theme.tokens.background.main.pressed
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: theme.tokens.background.tonal.soft.default,
        opacity: 1
      }
    },
    [`.${DROPDOWN_ITEM_CLASS_NAME}:not(.disabled):hover & .MuiSwitch-switchBase`]: {
      '& + .MuiSwitch-track': {
        backgroundColor: theme.tokens.foreground.main.disabled
      },
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          backgroundColor: theme.tokens.background.brand.main.hover
        }
      }
    },
    [`.${DROPDOWN_ITEM_CLASS_NAME}:not(.disabled).${listItemButtonClasses.focusVisible} & .MuiSwitch-switchBase`]: {
      '& + .MuiSwitch-track': {
        backgroundColor: theme.tokens.foreground.main.disabled
      },
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          backgroundColor: theme.tokens.background.brand.main.hover
        }
      }
    },
    [`.${DROPDOWN_ITEM_CLASS_NAME}:not(.disabled):active & .MuiSwitch-switchBase`]: {
      '& + .MuiSwitch-track': {
        backgroundColor: theme.tokens.background.tonal.soft.default
      },
      '& .MuiSwitch-thumb': {
        boxShadow: 'none'
      },
      '&.Mui-checked': {
        color: theme.tokens.foreground.main.staticWhite,
        '& > div': {
          backgroundColor: theme.tokens.background.brand.main.hover
        },
        '& + .MuiSwitch-track': {
          backgroundColor: theme.tokens.background.brand.main.pressed
        }
      }
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: '32px',
      height: '32px',
      borderRadius: theme.borderRadius.small,
      boxShadow: theme.elevation.mediumDepth
    },
    '& .MuiSwitch-track': {
      borderRadius: theme.borderRadius.medium,
      backgroundColor: theme.tokens.background.tonal.soft.default,
      opacity: 1
    }
  })
)

export const StyledThumb = styled(Grid)(
  ({ theme }): CSSObject => ({
    boxShadow: 'none',
    width: '32px',
    height: '32px',
    borderRadius: theme.borderRadius.small,
    backgroundColor: theme.tokens.background.main.default,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  })
)
